var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 34.3999C17.0208 34.3999 13.0612 32.1066 10.75 28.6666C10.8037 25.0833 17.9167 23.1124 21.5 23.1124C25.0833 23.1124 32.1963 25.0833 32.25 28.6666C31.0655 30.4303 29.4655 31.8757 27.5909 32.8755C25.7163 33.8753 23.6246 34.3988 21.5 34.3999ZM21.5 8.95825C22.9255 8.95825 24.2927 9.52455 25.3007 10.5326C26.3087 11.5406 26.875 12.9077 26.875 14.3333C26.875 15.7588 26.3087 17.126 25.3007 18.134C24.2927 19.142 22.9255 19.7083 21.5 19.7083C20.0745 19.7083 18.7073 19.142 17.6993 18.134C16.6913 17.126 16.125 15.7588 16.125 14.3333C16.125 12.9077 16.6913 11.5406 17.6993 10.5326C18.7073 9.52455 20.0745 8.95825 21.5 8.95825ZM21.5 3.58325C19.1472 3.58325 16.8173 4.04668 14.6436 4.94708C12.4698 5.84748 10.4947 7.16721 8.831 8.83092C5.47097 12.191 3.58333 16.7481 3.58333 21.4999C3.58333 26.2517 5.47097 30.8089 8.831 34.1689C10.4947 35.8326 12.4698 37.1524 14.6436 38.0528C16.8173 38.9532 19.1472 39.4166 21.5 39.4166C26.2518 39.4166 30.809 37.529 34.169 34.1689C37.529 30.8089 39.4167 26.2517 39.4167 21.4999C39.4167 11.592 31.3542 3.58325 21.5 3.58325Z",
    fill: "#004E60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.9fae50bc0ff98fceac6a601c4c87815b.svg";
export { ForwardRef as ReactComponent };